import { render, staticRenderFns } from "./ClientTaskDetails.vue?vue&type=template&id=4919e787&"
import script from "./ClientTaskDetails.vue?vue&type=script&lang=js&"
export * from "./ClientTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports